"use client";
// Current theme as React state, kept in sync with the <html> attribute.
import { useCallback, useSyncExternalStore } from "react";
import { applyTheme, readTheme, subscribeTheme, type Theme } from "./theme";

// Server render has no document; light matches the attribute layout.tsx ships.
const serverTheme = (): Theme => "light";

export interface ThemeState {
  theme: Theme;
  setTheme: (t: Theme) => void;
}

export function useTheme(): ThemeState {
  const theme = useSyncExternalStore(subscribeTheme, readTheme, serverTheme);
  const setTheme = useCallback((t: Theme) => applyTheme(t), []);
  return { theme, setTheme };
}
